import { PropsWithChildren } from 'react'

export default function ProductDetailSubHeading({
    children,
}: PropsWithChildren<{}>) {
    return <h4 className="font-bold text-md text-secondary mb-6">{children}</h4>
}
